import * as React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { Tooltip } from '@mui/material';
import Paper from '@mui/material/Paper';
import { KeyboardArrowDown, KeyboardArrowUp, Delete, Check } from '@mui/icons-material';
import Paginating from '../Paginating';
import api from '../../services/Api';
import { useState, useEffect } from 'react';
import Loading from '../Loading';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import { FaEye } from 'react-icons/fa';
import MyDialog from '../../utils/MyDeleteDialog';
import { getValidationClassName } from '../../utils/validationUtils';
import { getDeleteButtonClassName } from '../../utils/deleteUtils';
import { handleValidation } from '../../utils/handleValidate';
import MyAlert from '../../utils/MyAlert';


function Row(props) {

  const user = useAuthUser()
  const auth = useAuthHeader()

  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [openValidationAlert, setOpenValidationAlert] = React.useState(false);
  const [validated, setValidated] = useState(false);

  const handleDeleteClick = () => {
    setOpenDeleteDialog(true);
  };

  const handleValidationClick = async () => {
    try {
      const validationSuccessful = await handleValidation(row, user, auth, 'article');
      if (validationSuccessful) {
        setValidated(true);
        setOpenValidationAlert(true);
      }else{
        setValidated(false)
        setOpenValidationAlert(true);
      }
    } catch (error) {
    } finally {
    }
  };

  const [display, setDisplay] = useState()

  useEffect(() => {
    validated ? setDisplay("d-none") : setDisplay()
  }, [validated])
  

  return (
    <React.Fragment>
      {openValidationAlert && (
          <MyAlert
            showAlert={true}
            handleCloseAlert={() => setOpenValidationAlert(false)}
            severity= { validated ? "success" : "error"}
            heading={ validated ? "Validação efectuada com sucesso!" : "Erro ao Validar!"}
            message={ validated ? "Artigo validado com sucesso!" : "Artigo não Validado"}
            autoDismissTime={3000}
          />
        )}
      <div>
        <MyDialog row={row} open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)} url={'article'} title={'Artigo'} />
      </div>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUp  /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          <strong> {row?.title.split(",")[0]}</strong>{row?.title?.split(",")[1] ? ", "+row?.title?.split(",")[1] : ""}
        </TableCell>
        <TableCell>
          {
            row.autors.map((autor, index) => (
              <p key={index}>{autor.lastname} {autor.name} - <strong> <small> {autor.pivot.involvement}</small> </strong> </p>
            ))
          }
        </TableCell>
        <TableCell>{row.type}</TableCell>
        <TableCell>{row.date_published}</TableCell>
        <TableCell>{row.peer_review ? "Revisado" : "Não Revisado"}</TableCell>
        <TableCell>{row.edition ? row.edition+" ª Edição, " : ""} {row.publisher ? row.publisher+", " : ""} {row.place ? row.place+", ": ""} {row.pages_number} Páginas </TableCell>
        <TableCell>{(row.validation && row.validation2) ? "Validado" : ((row.validation && !row.validation2) || (!row.validation && row.validation2)) ? "1/2" : "0/2" }</TableCell>
        <TableCell>
          <div className='d-flex justify-content-end'>
            <Tooltip title="Validar" arrow  
              className={ display ? display : getValidationClassName(user, row) } 
              onClick={() => handleValidationClick(row, user, auth)}>
              <IconButton
                aria-expanded="false"
                size="small"
              >
              <Check style={{ color: "green" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Ver Detalhes" arrow onClick={ () => setOpen(!open)}>
              <IconButton
                aria-expanded="false"
                size="small"
              >
              <FaEye style={{ color: "green" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Apagar" arrow 
              className={display ? display : getDeleteButtonClassName(user(), row)}>
              <IconButton
                aria-expanded="false"
                size="small"
                onClick={handleDeleteClick}
              >
              <Delete style={{ color: "red" }} />
              </IconButton>
            </Tooltip>
          </div>
        </TableCell>
      </TableRow>
      <TableRow className="bg-light">
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft:70 }} colSpan={9}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Detalhes
              </Typography>
              <Typography gutterBottom component="div">
                <strong> <small>  Autor(es) </small> </strong>
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow style={{ backgroundColor: 'InfoBackground' }}>
                    <TableCell/>
                    <TableCell>Nome</TableCell>
                    <TableCell>Apelido</TableCell>
                    <TableCell>País de Origem</TableCell>
                    <TableCell>Nivel académico</TableCell>
                    <TableCell>Orcid</TableCell>
                    <TableCell>E-mail</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.autors?.map((autor, index) => (
                    <TableRow key={index}>
                      <TableCell/>
                      <TableCell >
                        {autor.name}
                      </TableCell>
                      <TableCell>{autor.last_name}</TableCell>
                      <TableCell>{autor.country}</TableCell>
                      <TableCell>{autor.academic_level}</TableCell>
                      <TableCell>{autor.orcid}</TableCell>
                      <TableCell>{autor.email}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <Typography gutterBottom component="div">
                <strong> <small>  Sobre a Obra(s) </small> </strong>
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow style={{ backgroundColor: 'InfoBackground'}}>
                    <TableCell/>
                    <TableCell>Link</TableCell>
                    <TableCell>Citação</TableCell>
                    <TableCell>Palavras Chave</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                   props.data?.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell/>
                      <TableCell >
                        {data.link}
                      </TableCell>
                      <TableCell>{data.citation}</TableCell>
                      <TableCell>{data.keywords}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


export default function CollapsibleTable({searchKey}) {

  const auth = useAuthHeader()

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const getData = async (page) => {
    
    const res = await api.get(`articles?page=${page}`,
    {
      headers: {
        Authorization: auth()
      }
    },
    {
      withCredentials: true
    })
    setData(res.data.articles)
    setTotalPages(res.data.articles.last_page)
    setLoading(false)
  }

  const getSearchData = async (searchKey, page) => {
  
    const res = await api.get(`articles/${searchKey}?page=${page}`,
    {
      headers: {
        Authorization: auth()
      }
    },
    {
      withCredentials: true
    })
    setData(res.data.articles)
    setTotalPages(res.data.articles.last_page)
    setLoading(false)
  }

  useEffect(() => {
    setLoading(true)
    if (searchKey !== '') {
      getSearchData(searchKey, currentPage)
    }else
      getData(currentPage);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchKey])


  return (
    <>
      { loading ? (
        <Loading/>
      ) : (
        <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead className='bg-success'>
            <TableRow>
              <TableCell/>
              <TableCell className='text-light'><strong>Título</strong></TableCell>
              <TableCell className='text-light'><strong>Autor(es)</strong></TableCell>
              <TableCell className='text-light'><strong>Tipo</strong></TableCell>
              <TableCell className='text-light'><strong>Data de publicação</strong></TableCell>
              <TableCell className='text-light'><strong>Revisao por pares</strong></TableCell>
              <TableCell className='text-light'><strong>Info Diversa</strong></TableCell>
              <TableCell className='text-light'><strong>Validações</strong></TableCell>
              <TableCell align="right" className='text-light'><strong>Acções</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              data?.data?.map((item, index) => (
                <Row key={index} row={item} data={[item]}/>
              ))
            }
          </TableBody>
        </Table>
        <Paginating currentPage={currentPage} total={totalPages} onPageChange={(page) => setCurrentPage(page)}/>
      </TableContainer>
      )}
  </> 
  );
}